<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-pen
      </v-icon> Create Knowledge Base
    </h2>
    <v-card
      color="#fff"
    >
      <br>
      <v-col
        class="text-right"
      >
        <v-btn
          color="dark red"
          @click="saveKnowledgeBase"
        >
          Save
        </v-btn>
        <v-btn
          color="red darken-3"
          @click="$router.go(-1);"
        >
          Cancel
        </v-btn>
      </v-col>
      <v-form ref="form">
        <v-card-title>
          <v-row>
            <v-col
              cols="12"
              lg="9"
            >
              <v-text-field
                v-model="title"
                label="Title*"
                hint="Name for your reference - 'DBSystems'."
                :rules="[(v) => !!v || 'This field is required']"
                outlined
                dense
                @input="createSlug"
              />
              <div
                ref="quillEditor"
                style="height: 400px;"
                class="mb-4"
              />
            </v-col>
            <v-col
              cols="12"
              lg="3"
            >
              <h5>Category <font color="red">
                *
              </font></h5>
              <v-select
                v-model="category"
                outlined
                :rules="[(v) => !!v || 'This field is required']"
                dense
                :items="categoryLists"
                item-value="id"
                item-text="name"
              />
              <v-btn
                x-small
                @click="openFormToCreateCategories"
              >
                + Add new category
              </v-btn>
              <!-- <h5>Tags</h5>
            <v-select
              v-model="tags"
              outlined
              dense
              :items="tagsLists"
              item-value="id"
              item-text="name"
              multiple
            />
            <v-btn
              x-small
              @click="openFormToCreateTag"
            >
              + Add new tags
            </v-btn> -->
              <h5>Slug <font color="red">
                *
              </font></h5>
              <v-text-field
                v-model="slug"
                outlined
                dense
              />
              <h5>Reading Time</h5>
              <v-text-field
                v-model="readingTime"
                disabled
                outlined
                dense
              />
              <h5>Meta Title <font color="red">
                *
              </font> <code>{{ metaTitle.length }}/60</code></h5>
              <v-text-field
                v-model="metaTitle"
                :rules="[(v) => !!v || 'This field is required']"
                outlined
                maxlength="60"
                dense
              />
              <h5>Meta Description <font color="red">
                *
              </font> <code>{{ description.length }}/160</code></h5>
              <v-textarea
                v-model="description"
                :rules="[(v) => !!v || 'This field is required']"
                outlined
                maxlength="160"
                dense
              />
            </v-col>
          </v-row>
        </v-card-title>
      </v-form>
    </v-card>
    <centre-spinner
      :loading="loading"
    />
    <create-tags-form
      v-if="openFormToCreateTags"
      @success="fetchTags"
      @closed="openFormToCreateTags = false"
    />
    <create-category-form
      v-if="openFormToCreateCategory"
      @success="fetchCategories"
      @closed="openFormToCreateCategory = false"
    />
  </v-container>
</template>
<script>
  import Quill from 'quill';
  import 'quill/dist/quill.snow.css';
  import createTagsForm from './createTagsForm.vue';
  import createCategoryForm from './createCategoryForm.vue';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import Constants from 'src/constants';
  export default {
    name: 'QuillEditor',
    components: {
      'create-tags-form': createTagsForm,
      'create-category-form': createCategoryForm,
      'centre-spinner': spinner,
    },
    data () {
      return {
        quill: null,
        title: '',
        description: '',
        category: [],
        tags: [],
        content: '',
        metaTitle: '',
        slug: '',
        loading: false,
        readingTime: '',
        openFormToCreateCategory: false,
        openFormToCreateTags: false,
      };
    },
    computed: {
      categoryLists () {
        return this.$store.getters['knowledgebase/getCategory'];
      },
      tagsLists () {
        return this.$store.getters['knowledgebase/getTags'];
      },
      metaTitleLength () {
        return this.metaTitle.length;
      },
    },
    watch: {
      content (newVal, oldVal) {
        this.generateReadingTime();
      },
    },
    mounted () {
      // Quill.register('modules/imageResize', ImageResize);
      this.quill = new Quill(this.$refs.quillEditor, {
        theme: 'snow',
        placeholder: 'Start writing your text here...',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'code', 'blockquote'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ header: [1, 2, 3, false] }],
            ['link', 'image'],
            [{ align: [] }],
          ],
        // imageResize: {
        //   modules: ['Resize', 'DisplaySize', 'Toolbar'],
        // },
        },
      });
      this.quill.on('text-change', () => {
        this.content = this.quill.root.innerHTML;
      });
      this.fetchCategories();
      this.fetchTags();
    },
    methods: {
      createSlug () {
        if (this.title !== '') {
          this.slug = this.title.replace(/[\s,:;?#_/!@&*()|`$%^+<>]+/g, '-').toLowerCase();
        }
      },
      generateReadingTime () {
        const wpm = 238;
        const words = this.quill.root.innerText.trim().split(/\s+/).length;
        this.readingTime = Math.ceil(words / wpm);
      },
      async saveKnowledgeBase () {
        if (this.$refs.form.validate() === false) {
          this.$store.dispatch('alert/onAlert', {
            message: 'Fill all required fields.',
            type: Constants.ALERT_TYPE_ERROR,
          });
          return;
        }
        if (this.content === '') {
          this.$store.dispatch('alert/onAlert', {
            message: 'Write a blog before proceeding.',
            type: Constants.ALERT_TYPE_ERROR,
          });
          return;
        }
        if (this.metaTitle.length > 60) {
          this.$store.dispatch('alert/onAlert', {
            message: 'Maximun 60 character is allowed for meta title',
            type: Constants.ALERT_TYPE_ERROR,
          });
          return;
        }
        if (this.description.length > 160) {
          this.$store.dispatch('alert/onAlert', {
            message: 'Maximum 160 character is allowed for meta description',
            type: Constants.ALERT_TYPE_ERROR,
          });
          return;
        }
        this.loading = true;
        await this.$store.dispatch('knowledgebase/createKnowledgeBase', {
          title: this.title,
          description: this.description,
          meta_title: this.metaTitle,
          content: [this.content],
          reading_time: this.readingTime.toString(),
          slug: this.slug,
          category: this.category,
          // tags: this.tags,
        }).then(response => {
          this.$store.dispatch('alert/onAlert', {
            message: 'Knowledgebase created successfully and save to draft.',
            type: Constants.ALERT_TYPE_SUCCESS,
          });
          this.$router.go(-1);
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });
      },
      openFormToCreateTag () {
        this.openFormToCreateTags = true;
      },
      openFormToCreateCategories () {
        this.openFormToCreateCategory = true;
      },
      async fetchCategories () {
        this.loading = true;
        await this.$store.dispatch('knowledgebase/fetchCategory').then(response => {
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });
      },
      async fetchTags () {
        this.loading = true;
        await this.$store.dispatch('knowledgebase/fetchTags').then(response => {
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });
      },
    },
  };
</script>

<style>
.output {
  margin-top: 20px;
  padding: 10px;
  border: 1px solid #ddd;
  background-color: #f9f9f9;
}
code {
  float: right;
  padding: 0px!important;

}
.theme--light.v-application code{
  background-color: #fff;
}
</style>
